module.exports = __webpack_public_path__ + "img/nav-about-movie.a5d626d.jpg";